export { Labyrinth as default } from './labyrinth';
